import { render, staticRenderFns } from "./TextCopyButton.vue?vue&type=template&id=a0585a08&"
import script from "./TextCopyButton.vue?vue&type=script&lang=js&"
export * from "./TextCopyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports